// Lucide icon: thumbs-down (https://lucide.dev/icons/thumbs-down)
import { ThumbsDown } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconThumbsDown = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <ThumbsDown />
    </IconComponentStyled>
  )
}
